import { render, staticRenderFns } from "./FormItemTradeReference.vue?vue&type=template&id=2c9c0841"
import script from "./FormItemTradeReference.vue?vue&type=script&lang=js"
export * from "./FormItemTradeReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports